function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.001 21.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 0a10 10 0 1 0 10 10A10 10 0 0 0 10 0z",
    style: {
      stroke: "transparent",
      strokeMiterlimit: 10
    },
    transform: "translate(.5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.09 8.821a2.3 2.3 0 0 0-1.551 2.315l.024.394-.4-.048A6.466 6.466 0 0 1 8.38 9.617l-.525-.523-.134.386a2.324 2.324 0 0 0 .493 2.38c.318.338.246.386-.3.185a.927.927 0 0 0-.374-.088 2.885 2.885 0 0 0 .286 1.078 2.571 2.571 0 0 0 1.089 1.029l.39.185-.462.007c-.445 0-.461.008-.413.178a2.4 2.4 0 0 0 1.487 1.319l.493.169-.429.258a4.451 4.451 0 0 1-2.131.594 2.345 2.345 0 0 0-.653.064 6.094 6.094 0 0 0 1.534.708 6.711 6.711 0 0 0 5.217-.6A6.988 6.988 0 0 0 16.6 13.83a8.288 8.288 0 0 0 .541-2.411c0-.37.024-.418.469-.86a5.348 5.348 0 0 0 .557-.619c.08-.153.071-.153-.334-.016-.676.241-.771.209-.437-.153a2.347 2.347 0 0 0 .541-.86c0-.024-.119.016-.254.088a4.362 4.362 0 0 1-.7.273l-.429.137-.389-.266a3.244 3.244 0 0 0-.676-.354 2.716 2.716 0 0 0-1.393.033z",
    transform: "translate(-2.198 -2.767)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.083f28a8.svg";
export { ForwardRef as ReactComponent };